export function generateRandomId() {
  const characters = 'abcdefghijklmnopqrstuvwxyz0123456789';
  const length = Math.floor(Math.random() * 3) + 9;
  return Array.from({ length }, () =>
    characters.charAt(Math.floor(Math.random() * characters.length))
  ).join('');
}

export function extractIssuesSorted(data) {
  return data
    .map((category) => {
      const resultSections = [];

      for (const section of category.sections) {
        section.checkboxes.forEach((value, index) => {
          if (value === true && (index === 1 || index === 2)) {
            const label = section.checkboxLabels[index];
            resultSections.push({ [label]: section.description });
          }
        });
      }

      resultSections.sort((a, b) => {
        const aKey = Object.keys(a)[0];
        const bKey = Object.keys(b)[0];

        if (aKey === bKey) return 0;
        if (aKey === 'Fail') return -1;
        if (bKey === 'Fail') return 1;
        return 0;
      });

      return {
        title: category.title,
        sections: resultSections,
      };
    })
    .filter((item) => item.sections.length > 0);
}
